import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './plugins/router'
import VImageInput from 'vuetify-image-input/a-la-carte';

Vue.config.productionTip = false

Vue.component('VImageInput', VImageInput);


const moment = require('moment')
require('moment/locale/de');


Vue.use(require('vue-moment'), {
  moment
})


new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
